import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'Encrypted Data',
      description: 'Your personal information is protected with military-grade encryption',
      color: 'var(--color-primary)',
    },
    {
      icon: 'Lock',
      title: 'Secure Authentication',
      description: 'Advanced security protocols keep your account safe from unauthorized access',
      color: 'var(--color-accent)',
    },
    {
      icon: 'Eye',
      title: 'Privacy First',
      description: 'We never share your data with third parties without your explicit consent',
      color: 'var(--color-secondary)',
    },
  ];

  return (
    <div className="space-y-md">
      <div className="flex items-center gap-sm pb-sm border-b border-primary/30">
        <Icon name="ShieldCheck" size={24} color="var(--color-primary)" />
        <h3 className="text-lg font-heading font-semibold text-primary">
          Security Assurance
        </h3>
      </div>
      <div className="space-y-sm">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex gap-md p-sm bg-background rounded-sm border border-primary/20 hover:border-primary/40 transition-all duration-base"
          >
            <div className="flex-shrink-0 w-10 h-10 bg-card rounded-sm flex items-center justify-center border border-primary/30">
              <Icon name={feature?.icon} size={20} color={feature?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-caption font-semibold text-foreground mb-xs">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="pt-sm">
        <div className="flex items-start gap-sm p-sm bg-accent/10 rounded-sm border border-accent/30">
          <Icon name="Info" size={18} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <p className="text-xs text-foreground leading-relaxed">
            By creating an account, you're joining a secure gaming environment where your data privacy and account security are our top priorities.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecurityFeatures;